import {GET_PROFIT} from '../types';
import {GET_PROFIT_DONE} from '../types';
import {SET_PROFIT_TIME_FROM_MAX} from '../types';
import {SET_PROFIT_TIME_TO_MAX} from '../types';
import {SET_PROFIT_TIME_FROM} from '../types';
import {SET_PROFIT_TIME_TO} from '../types';

import axios from 'axios';
import {domain, formatDate, naturalUrlAttr} from "../../config";
import moment from "moment";

export const setProfitDone = (state) => async dispatch=> {
    dispatch({
        type: GET_PROFIT_DONE, payload: state
    });
}

export const getProfit = (dates) => async dispatch => {

    try {
        let params = {};

        if (dates) {
            params.from = (+new Date(`${moment(dates[0]).format('MM-DD-YYYY')} 00:00:00`)) / 1000;
            params.to = (+new Date(`${moment(dates[1]).format('MM-DD-YYYY')} 23:59:59`)) / 1000;
        }

        const response = await axios.get(`${domain}profit/get`, {params});

        const profitData = response.data;

        if (!dates) {
            dispatch({
                type: SET_PROFIT_TIME_FROM_MAX, payload: parseInt(profitData.investment[0].ordTotals_from) * 1000
            });
            dispatch({
                type: SET_PROFIT_TIME_TO_MAX, payload: parseInt(profitData.investment[0].ordTotals_to) * 1000
            });
        }

        dispatch({
            type: GET_PROFIT_DONE, payload: true
        });

        dispatch({
            type: SET_PROFIT_TIME_FROM, payload: parseInt(profitData.daily[0].period_from) * 1000
        });

        dispatch({
            type: SET_PROFIT_TIME_TO,
            payload: parseInt(profitData.daily[profitData.daily.length - 1].period_from) * 1000
        });

        dispatch({
            type: GET_PROFIT, payload: profitData
        });

    } catch (e) {
        console.log('Error profit');
    }
};

export const setProfitTimeFrom = (profitTimeFrom) => dispatch => {
    dispatch({
        type: SET_PROFIT_TIME_FROM, payload: profitTimeFrom
    });
};

export const setProfitTimeTo = (profitTimeTo) => dispatch => {
    dispatch({
        type: SET_PROFIT_TIME_TO, payload: profitTimeTo
    });
};